<template>
  <div class="skeleton__container">
    <div class="skeleton-box skeleton__title" />
    <div
      v-for="item in [1, 2, 3]"
      :key="item"
      class="skeleton-box skeleton__item"
    />
  </div>
</template>

<style lang="scss" scoped>
@import "frontend/web/src/styles/utils/variables.scss";
.skeleton {
  &__container{
    display: flex;
    flex-direction: column;
    gap: 18px;
    margin-bottom: 80px;
  }
  &__title {
    max-width: 400px;
    height: 36px;
    background-color: $grey-third;
    margin-bottom: 12px;
    border-radius: 12px;
  }

  &__item {
    width: 100%;
    height: 132px;
    background-color: $grey-third;
    border-radius: 16px;

    @media screen and (max-width: $screen-md-min) {
      height: 261px;
    }
  }
}
</style>
